<template>
    <div class="bgcolor bgpadding">
        <!-- <el-row> -->
            <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" style="box-sizing: border-box;float: none;margin: 0 auto;"> -->
            <div class="warp_container">
                <div class="order_top white_bg">
                    <div class="order_top_warp">
                        <div class="pay-jdL">
                            <div style="color:#00C590;">提交订单</div>
                            <i></i>
                        </div>
                        <div class="pay-jd">
                            <span class="pay_tips">请在30分钟内完成支付！逾期将自动取消！</span>
                            <span class="pay-num"></span>
                        </div>
                        <div class="pay-jdL pay-jdR">
                            <div>完成支付</div>
                            <i></i>
                        </div>
                    </div>
                </div>
                <div class="order_conter white_bg top" style="position: relative;">
                    <img class="order_conter_img" :src="orderData.goods_img" alt="">
                    <div class="discount_name">{{orderData.order_title}}</div>
                    <div class="discount_price mian_right">
                        <div>￥{{orderData.order_amount_oringal}}</div>
                        <span v-if="orderData.coupon_amount>0" class="order_amount_txt">优惠券抵扣￥{{orderData.coupon_amount}}</span>
                    </div>
                </div>
                
                <div class="pay_way white_bg top">
                    <div class="pay_txt">选择支付方式</div>
                    <div class="way_box">
                        <div class="pay_btn_box pay_min_width" :class="type==='alipay'? 'actice_pay_btn':''" @click="payType('alipay')">
                            <i class="apay"></i><span>支付宝</span>
                        </div>
                        <div class="pay_btn_box pay_min_width" :class="type==='wxpay'? 'actice_pay_btn':''" @click="payType('wxpay')">
                            <i class="wpay"></i><span>微信支付</span>
                        </div>
                    </div>
                </div>
                <div class="submt white_bg top">
                    <div class="submt_price">
                        <!-- {{Object.prototype.toString.call(orderData) === '[object Object]'&&orderData.stages_item_info.stages_item_sn ? 
                        orderData.stages_item_info.indexdiscount_name_text+'期：':'合计：'}} -->
                        <span class="discount_price">￥{{orderData.order_amount}}</span>
                        <!-- <div class="installment_txt_box" v-if="Object.prototype.toString.call(orderData) === '[object Object]'&&orderData.stages_item_info.stages_item_sn">
                            <img src="../assets/installment.png">
                            <span>分期</span>
                        </div> -->
                    </div>
                    <div class="submt_btn" @click="pay" v-if="checked">确认支付</div>
                    <div class="submt_btn sbt_btn_disabled" @click="pay" v-else>确认支付</div>
                </div>
                <div class="agree">
                    <img @click="checked=!checked" class="ac" :src="checked ? require('../assets/all_right.png') : require('../assets/no.png')"><span class="agree_txt_wrap">我已阅读并同意相关</span><span class="clause_txt" @click="clause=true">服务条款</span>和<span class="clause_txt" @click="clause1=true">隐私政策</span>
                </div>
            </div>    
            <!-- </el-col> -->
        <!-- </el-row> -->
        <!-- 微信支付 -->
        <el-dialog title="正在支付" width="300px" @open="opendialo" @close="closedialo" :visible.sync="dialogwx" class="wx_dialog" center>
            <img :src="code_url" />
            <div slot="footer" class="wx_dialog_footer">
                <a @click="checkOrder">完成支付</a>
                <span>|</span>
                <a  @click="pay">刷新二维码</a>
            </div>
        </el-dialog>
        <!-- 支付宝支付 -->
        <el-dialog title="正在支付" width="300px" @open="opendialo" @close="closedialo" :visible.sync="dialogalibaba" class="wx_dialog ali_dialog" center>
            <div>请在跳转页面完成支付</div>
            <div slot="footer">
                <a @click="checkOrder" class="alpaybtn">我已完成支付</a>
            </div>
        </el-dialog>
        <!-- 条款 -->
        <el-dialog title="服务协议" :visible.sync="clause" class="clause_dialog" center>
            <div class="clause_dialog_txt"><el-scrollbar style="height:100%;">欢迎您使用翰墨教育！ <br/>为使用翰墨教育服务（以下简称“本服务”），您应当阅读并遵守《服务协议》（以下简称“本协议”）等相关协议、业务规则。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制或免除责任条款可能以加粗形式提示您注意。 <br/>除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您对本服务的登陆、查看、发布信息等行为即视为您已阅读并同意受本协议的约束。 <br/>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。 一、【协议的范围】 本协议是您与翰墨教育之间关于使用本服务所订立的协议。</el-scrollbar></div>
            <div slot="footer">
                <a @click="agree" class="agree_btn">同意</a>
            </div>
        </el-dialog>
        <el-dialog title="隐私政策" :visible.sync="clause1" class="clause_dialog" center>
            <div class="clause_dialog_txt"><el-scrollbar style="height:100%;">欢迎您使用翰墨教育！ <br/>为使用翰墨教育服务（以下简称“本服务”），您应当阅读并遵守《服务协议》（以下简称“本协议”）等相关协议、业务规则。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制或免除责任条款可能以加粗形式提示您注意。 <br/>除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您对本服务的登陆、查看、发布信息等行为即视为您已阅读并同意受本协议的约束。 <br/>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。 一、【协议的范围】 本协议是您与翰墨教育之间关于使用本服务所订立的协议。</el-scrollbar></div>
            <div slot="footer">
                <a @click="agree" class="agree_btn">同意</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Scan from '@/components/Scan'
    import store from '../store'
    export default {
        components: {Scan},
        data () {
            return {
                orderData:'',
                type:'',
                code_url:'',
                dialogwx:false,
                dialogalibaba:false,
                apitimer:null,
                checked: false,
                clause: false,
                clause1: false
            }
        },
        methods:{
            getData() { //页面数剧请求
                var data={scene: 'pay'};
                this.$route.query.order_sn ? data.order_sn=this.$route.query.order_sn:'';
                this.$route.query.stages_item_sn ? data.stages_item_sn=this.$route.query.stages_item_sn:'';
                this.$http.get('/api/v2/course_order/getOrderInfo',{
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):''
                    },
                    params: data
                })
                .then((res) => {
                    if(res.data.code===1){
                        this.orderData=res.data.data;
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true); //弹出登录窗口
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
            pay() { //支付事件
                if(!this.checked){
                    this.$message('请勾选同意条款')
                    return false;
                }

                if(this.type==''){
                    this.$message({
                        message: '请选择支付方式',
                        type: 'warning'
                    });
                }else{
                    
                    var data={
                        order_sn: this.$route.query.order_sn
                        // course_id: this.$route.query.course_id
                    };
                    if(this.type=="alipay"){
                        data.return_url=`http://${window.location.host}/accountPaid?order_sn=${this.orderData.order_sn}`
                        // data.return_url=null
                    }
                    this.type=="alipay" ? data.opt="alipay_pc" : this.type=="wxpay"? data.opt="wxpay_pc" : "";
                    // this.$route.query.order_sn ? data.order_sn=this.$route.query.order_sn:
                    // this.$route.query.stages_item_sn ? data.stages_item_sn=this.$route.query.stages_item_sn:'';

                    this.$http.post('/api/v2/course_order/createThirdPayOrder',data,
                        {
                            headers:
                                {
                                    'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                                }
                        }
                    ).then((res) => {

                        if(res.data.code===0){
                            this.$message.error(res.data.msg);
                        }else if(res.data.code===10001){
                            store.commit('setDialogLogin',true); //弹出登录窗口
                        }else{

                            if (res.status == 200)
                            {
                                if(this.type == 'alipay'){
                                    localStorage.setItem('fromUrl',res.data);
                                    let routerData = this.$router.resolve({path:'/scan'})
                                    window.open(routerData.href, '_blank')
                                    this.dialogalibaba=true;
                                }
                            }

                            if(res.data.code===1){
                                if(this.type == 'wxpay'){
                                    this.code_url = res.data.data
                                    this.dialogwx=true; 
                                }   
                            }
                        }
                        

                            // this.$router.push({name:'pay',params:{course_id:this.$route.params.course_id}});
                        // }else if(res.data.code===0){
                        //     this.$message.error(res.data.msg)
                        // }else if(res.data.code===10001){
                        //     store.commit('setDialogLogin',true);
                        // }

                    }).catch((err) => {
                            // console.log(err);
                    })
                }
            },
            payType(type) { //支付方式选择
                this.type=type;
            },
            checkOrder() { //完成支付点击跳转事件
                this.$http.get('/api/v2/course_order/checkThirdPayOrder',{
                    headers:{ 'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'' },
                    params:{
                        order_sn: this.orderData.order_sn
                    }
                }).then((res) => {
                    if(res.data.code===1){
                        if(res.data.data.order_status==='paid'||res.data.data.order_status==='complete') {
                            // if(res.data.data.write_address===1){
                                this.$message({
                                    message: '支付完成',
                                    type: 'success'
                                });
                                this.$router.push({path:'/accountPaid',query:{order_sn: this.orderData.order_sn}});
                            // }else if(res.data.data.write_address===0){
                                // this.$message({
                                //     message: '支付完成',
                                //     type: 'success'
                                // });
                                // var that=this;
                                // window.setTimeout(function(){
                                //     that.$router.push({name:'courseDescription', params: {course_id:that.$route.query.course_id}})
                                // },800);
                            // }
                        }else{
                            this.$message.error("您的订单尚未支付")
                        }
                   }else if(res.data.code===0){
                       this.$message.error(res.data.msg)
                   }else if(res.data.code===10001){
                       store.commit('setDialogLogin',true);
                   }
                }).catch((err) => {
                    // console.log(err);
                })
            },
            iteratorAPI() { //倒计时请求支付完成
                this.apitimer=setInterval(() => {
                    this.$http.get('/api/v2/course_order/checkOrder',{
                        headers:{ 'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'' },
                        params:{
                            order_sn: this.orderData.order_sn
                        }
                    }).then((res) => {
                        if(res.data.code===1){
                            if(res.data.data.order_status==='paid'||res.data.data.order_status==="complete") {
                                clearInterval(this.apitimer);
                                this.apitimer = null;
                                // if(res.data.data.write_address===1){
                                    this.$router.push({path:'/accountPaid',query:{order_sn: this.orderData.order_sn}});
                                // }else if(res.data.data.write_address===0){
                                    // this.$message({
                                    //     message: '支付完成',
                                    //     type: 'success'
                                    // });
                                    // var that=this;
                                    // window.setTimeout(function(){
                                    //     that.$router.push({name:'courseDescription', params: {course_id:that.$route.query.course_id}})
                                    // },800);
                                // }
                            }
                        }
                    })
                }, 2000)
            },
            closedialo() { //关闭支付窗口取消倒计时
                clearInterval(this.apitimer);
                this.apitimer = null;
            },
            opendialo() {
                this.iteratorAPI();
            },
            agree() { //点击同意
                this.checked=true;
                this.clause ? this.clause=false : this.clause1 ? this.clause1=false: '';
            }
        },
        created() {
            this.$changeTitle('订单支付--');
            this.getData();
            store.commit('setNav',null);
        },
        destroyed() {
            clearInterval(this.apitimer);
            this.apitimer = null;
        }
    }
</script>

<style scoped>
    .bgpadding{
        padding-bottom: 0;
    }
    .order_top_warp{
        width: 520px;
        margin: 0 auto;
        height: 160px;
        padding: 20px 0;
        overflow: hidden;
        position: relative;
    }
    .pay-jdL {
        width: 100px;
        text-align: center;
        /* float: left; */
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
    }
    .pay-jdL i {
        background: url('../assets/dingdan3.png') no-repeat 0 0;
        background-size: cover;
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .pay-jdR i {
        background: url('../assets/dingdan2.png') no-repeat 0 0;
        background-size: cover;
    }
    .pay-jdL div {
        color: #999;
        font-size: 18px;
        padding-bottom: 10px;
    }
    .pay-jdR {
        right: 0;
    }
    .pay-jd {
        width: 390px;
        height: 4px;
        background: #999;
        float: left;
        position: absolute;
        top: 54%;
        left: 64px;
    }
    
    .pay-jd .pay-num {
        display: block;
        height: 4px;
        /* background: #999; */
        background:linear-gradient(30deg,rgba(9,209,120,1),rgba(0,202,129,1));
        width: 50%;
    }
    .pay_tips{
        position: absolute;
        left: 45px;
        bottom: 10px;
        color: #999999;
        display: inline-block;
        width: 310px;
    }
    .order_conter{
        height: 240px;
        box-sizing: border-box;
        padding: 30px;
        line-height: 200px;
    }
    .order_conter_img{
        width: 380px;
        height:180px;
        float:left;
        margin-right: 30px;
        border-radius:10px;
        background: #000;
    }
    .mian_right{
        /* float: right; */
        position: absolute;
        line-height: normal;
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
        text-align: right;
    }
    .order_amount_txt{
        font-size: 18px;
    }
    .ord_title{
        color: #333;
        font-size: 18px;
        margin: 20px 0;
    }
    .jianjie{
        margin: 18px 0 22px;
    }
    .discount_price{
        color: #FF6029;
        font-size: 24px;
    }
    .discount_name{
        float:left;
        color: #333;
        font-size: 18px;
    }
    /* .mian_left{
        display: inline-block;
        margin-right: 50px;
        border-radius:10px;
    }
    .mian_left span{
        vertical-align: middle;
    } */
    .top{
        margin-top: 20px;
    }
    .pay_way{
        height: 90px;
        line-height: 30px;
        padding: 30px 30px;
        font-size: 16px;
        color: #333;
        box-sizing: border-box;
        position: relative;
    }
    .way_box{
        /* margin-left: 160px; */
        position: absolute;
        left: 198px;
        top: 50%;
        transform: translateY(-50%);
    }
    .pay_btn_box{
        width:150px;
        height:50px;
        line-height: 50px;
        /* border:2px solid #999999; */
        border-radius:25px;
        display: inline-block;
        margin-right: 60px;
        cursor: pointer;
        position: relative;
    }
    .pay_min_width{
        min-width: 90px;
    }
    .pay_btn_box:hover{
        border:2px solid #00C590;
    }
    .actice_pay_btn{
        border:2px solid #00C590;
    }
    .pay_btn_box i{
        display: inline-block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 17px;
        background-size: cover;
    }
    .pay_btn_box span{
        margin-left: 60px;
    }
    .apay{
        width: 35px;
        height: 35px;
        font-size: 16px;
        background: url('../assets/zfb.png') no-repeat 0 0;
    }
    .wpay{
        width: 34px;
        height: 29px;
        font-size: 16px;
        background: url('../assets/wx.png') no-repeat 0 0;
    }
    .submt{
        padding: 0 30px;
        height: 100px;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        /* margin-bottom: 60px; */
    }
    .submt_price{
        float: left;
        font-size: 18px;
        /* line-height: 100px; */
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .installment_txt_box{
        font-size: 18px;
        color: #00C590;
        margin-left: 18px;
        display: inline-block;
    }
    .installment_txt_box img{
        width: 20px;
        height: 25px;
    } 
    .installment_txt_box img,.installment_txt_box span{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .installment_txt_box span{
        white-space: nowrap;
        display: inline-block;
        margin-left: 24px;
    }
    .submt_btn{
        float: right;
        width:150px;
        height:50px;
        background:#FF6029;
        border-radius:25px;
        font-size:20px;
        color: #ffffff;
        line-height: 50px;
        text-align: center;
        margin: 25px 0;
        cursor: pointer;
    }
    .sbt_btn_disabled{
        background: #99999982;
    }
    .btn_disabled{
        float: right;
        width:150px;
        height:50px;
        border-radius:25px;
        font-size:20px;
        line-height: 50px;
        text-align: center;
        margin: 25px 0;
        padding: 0;
    }
    .wx_dialog_footer{
        cursor: pointer;
    }
    .alpaybtn{
        display: inline-block;
        border-radius:25px;
        border: 1px solid #999;
        padding: 8px 10px;
        cursor: pointer;
    }
    /* 条款 */
    .agree{
        height: 80px;
        width: 100%;
        font-size: 18px;
        color: #999999;
        text-align: center;
        line-height: 80px;
        position: relative;
    }
    .ac{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
    }
    .agree_txt_wrap{
        margin-left: 32px;
    }
    .clause_txt{
        color: #00C590;
        cursor: pointer;
    }
    /* 条款弹框 */
    .clause_dialog_txt{
        width:563px;
        height:281px;
        font-size:16px;
        overflow: auto;
    }
    .agree_btn{
        display: inline-block;
        width:120px;
        height:40px;
        background:#00C590;
        border-radius:20px; 
        font-size: 20px;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
    }
</style>
<style>
    .wx_dialog .el-dialog__body{
        text-align: center  !important;
    }
    .ali_dialog .el-dialog{
        border-radius: 10px;
    }
    .clause_dialog .el-dialog{
        border-radius: 20px;
        width:620px;
        height:460px;
    }
</style>


// WEBPACK FOOTER //
// src/page/Pay.vue